
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 4.413L2.419.606A.928.928 0 013.167 0h7.486a.7.7 0 01.447.178 1.052 1.052 0 01.3.428l2.42 3.807zm4.722-3.29a.829.829 0 00-.806.848.829.829 0 00.806.848H9.1a.829.829 0 00.8-.848.829.829 0 00-.8-.848zM0 4.912h13.822v5.491a1.183 1.183 0 01-1.183 1.183H1.183A1.183 1.183 0 010 10.403z","fill":"inherit"}})])
          )
        }
      }
    